import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function normalizeEmail(email: string): string {
	return email.trim().toLowerCase();
}

export function getInitials(name: string | null, email?: string): string {
	if (name) {
		return name
			.split(' ')
			.map((n) => n[0])
			.join('')
			.toUpperCase()
			.slice(0, 2);
	}
	return email?.[0]?.toUpperCase() ?? '?';
}

/**
 * Normalizes Clerk organization roles by stripping the 'org:' prefix
 * Clerk stores roles as 'org:admin' or 'org:member', but our database and logic expects 'admin' or 'member'
 * @param role - The role from Clerk (e.g., 'org:admin', 'org:member')
 * @returns The normalized role without prefix (e.g., 'admin', 'member'), or null if role is falsy
 */
export function normalizeClerkRole(role: string | null | undefined): string | null {
	if (!role) {
		return null;
	}
	return role.replace('org:', '');
}
